"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAPropertiesCompact = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * IA properties that are used by the individual applications compact requests.
 */
class IAPropertiesCompact {
}
exports.IAPropertiesCompact = IAPropertiesCompact;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE, _c = echain_shared_igus_fundamentals_1.AppName.EIC, _d = echain_shared_igus_fundamentals_1.AppName.ECF;
IAPropertiesCompact[_a] = [
    'Id',
    'EchainId',
    'ArtNr',
    'ArticleSpecs',
    'Artikeltyp',
    'Bezeichnung',
    'Breite',
    'Gewicht',
    'IARef',
    'KetteRef',
    'KetteSerieRef',
    'Kind',
    'Montiert',
];
IAPropertiesCompact[_b] = IAPropertiesCompact[echain_shared_igus_fundamentals_1.AppName.EIQ];
IAPropertiesCompact[_c] = IAPropertiesCompact[echain_shared_igus_fundamentals_1.AppName.EKE];
IAPropertiesCompact[_d] = ['EchainId'];
//# sourceMappingURL=IAPropertiesCompact.js.map